// extracted by mini-css-extract-plugin
export default {"ListItemTitle_0":"IssuePullRequestTitle-module__ListItemTitle_0--ORbH2","ListItemTitle_1":"IssuePullRequestTitle-module__ListItemTitle_1--FWLq8"};